const getPaymentSystemCombinedTransactionsScopes = [
  'PAYMENT_SYSTEM_COMBINED_TRANSACTIONS_REMOVED',
];
const chains = [];
chains.push({ _operation: 'getPaymentSystemCombinedTransactions', api: '/payment-system-combined-transactions', defaultData: [], httpVerb: 'get', scopes: getPaymentSystemCombinedTransactionsScopes });
export default chains;
